globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.KeyboardShortcuts = (function() {
  function KeyboardShortcuts() {
    this.init();
  }

  KeyboardShortcuts.prototype = {
    init: function() {
      var listener = new window.keypress.Listener();

      listener.register_many([
        {
          keys: 'alt c',
          on_release: function() {
            window.location = appVisitor.config.toolConnexionBaseUrl;
          }
        }
      ]);
    }
  }

  return KeyboardShortcuts;
})();
